<template>
    <div>
        <loading :active.sync="loadingApp" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">List Downline</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div class="section detail-transaction-section pt-2" style="--height:90px;">
                <div class="detail-card text-center">
                    <h1 style="font-size:50px;" class="mb-0 mt-2">{{downline_total}}</h1>
                    <p class="mb-0">Total Downline</p>
                </div>
            </div>
            <div class="section mt-2">
                <button class="btn btn-primary btn-block" @click="actionSheet('show')"><ion-icon name="add-circle"></ion-icon> Tambah Downline</button>
            </div>
            <div class="section full mt-2">
                <div v-if="downline.data.length > 0">
                    <ul class="listview image-listview-product inset">
                        <li v-for="item in downline.data" :key="item.id">
                            <div class="item pl-3 pr-3">
                                <div class="in">
                                    <div style="width: 90%;">
                                        <small>{{ item.created_at }}</small>
                                        <h4>{{ item.name }}</h4>
                                        <footer>{{ item.phone }}</footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <h4 class="ml-05 mb-05">Rp {{ item.balance | rupiah }}</h4>
                                        <div class="chip chip-success ml-05 mb-05" v-if="item.status == 'ACTIVE'">
                                            <span class="chip-label">Aktif</span>
                                        </div>
                                        <div class="chip chip-warning ml-05 mb-05" v-else-if="item.status == 'INACTIVE'">
                                            <span class="chip-label">Tidak Aktif</span>
                                        </div>
                                        <div class="chip chip-danger ml-05 mb-05" v-else>
                                            <span class="chip-label">Banned</span>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="m-2 text-center" v-if="downline.next_page_url">
                        <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary rounded mr-1 mb-1'" @click.native="paginateDownline(downline.next_page_url)">Lihat lebih banyak</ButtonLoader>
                    </div>
                </div>
                <div class="text-center" style="margin-top:50px;" v-else>
                    <img :src="require('@/assets/image/404.svg')" alt="404" class="w-75 mb-3"><br>
                    <i>Data belum tersedia</i>
                </div>
            </div>
        </div>
        <action-sheet ref="add_downline" :title="'Tambah Downline'" :inset="true">
            <div class="form-group basic">
                <label class="label">Nama</label>
                <input type="text" class="form-control form-control-sm text-capitalize" v-model="downline_data.name" maxlength="25">
                <small><i>Maks. 20 Karakter</i></small>
            </div>
            <div class="form-group basic">
                <label class="label">No. handphone (WhatsApp)</label>
                <input type="number" class="form-control form-control-sm" v-model="downline_data.phone" maxlength="13">
                <small><i>Min. 10 digit & Maks. 13 digit</i></small>
            </div>
            <div class="form-group basic">
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-secondary btn-block" @click="actionSheet('hide')"> Batal</button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary btn-block'" @click.native="storeDownline()">Simpan</ButtonLoader>
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import $axios from './../../api.js'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            affiliate_id: '',
            loadingApp: true,
            loadingButton: false,
            downline: {
                data: [],
            },
            downline_total: '0',
            downline_data:{
                name: '',
                phone: '',
            }
        }
    },
    computed: {
        ...mapState(['toast','VUE_ENV', 'customer', 'setting'])
    },
    methods:{
        ...mapActions(['getCustomer','getSetting']),
        paginateDownline(url = ''){
            this.loadingButton = true
            $axios.get(url ? url:'/referral/downline')
            .then(response => {
                this.downline_total = response.data.data.total
                if(!this.downline.data){
                    this.downline = response.data.data
                }else{
                    this.downline.data.push(...response.data.data.data)
                    this.downline.next_page_url = response.data.data.next_page_url
                }
                this.loadingButton = false
                this.loadingApp = false
            }).catch(() => {
                this.loadingButton = false
                this.loadingApp = false
            })
        },
        actionSheet(value){
            let element = this.$refs.add_downline.$el
            window.$(element).modal(value)
        },
        storeDownline(){
            this.loadingButton = true
            $axios.post('/referral/downline/create', this.downline_data)
            .then((response) => {
                this.downline = {
                    data: [],
                },
                this.paginateDownline()
                this.actionSheet('hide')
                this.loadingButton = false
                this.$store.commit('SET_TOAST', {show:true,message:response.data.message,tipe:'default',icon:'success'})
            }).catch((error) => {
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.actionSheet('hide')
                this.loadingButton = false
            })
            this.downline_data = {
                name: '',
                phone: ''
            }
        }
    },
    mounted(){
        this.paginateDownline()
    },
    destroyed(){
        this.$store.commit('RESET_TOAST')
    }
}
</script>